module.exports = __webpack_public_path__ + "img/settings.02093199.png";